import React, { useEffect, useState } from 'react';

import { 
  Condition
} from "@dndModels";
import {
  DAMAGE_TYPES
} from "@dndModels/Constants";
import { DisablableOption, toDisablableOption } from "@models";

import DandDAPI from '@dndUtilities/system_api';

import SelectStringBox from '@components/input/selects/SelectStringBox';

interface Props {
  name: string;
  value?: string;
  values?: string[];
  option_objects?: Condition[];
  onChange: Function;
  color?: string;
  multiple?: boolean;
  resistances?: boolean;
  vulnerabilities?: boolean;
  immunities?: boolean;
  disabled?: boolean;
  extra_options?: string[];
}

const api = DandDAPI.getInstance();

export default function SelectConditionBox({ 
  name,
  value,
  values,
  option_objects,
  onChange,
  color = "",
  multiple = false,
  resistances = false,
  vulnerabilities = false,
  immunities = false,
  disabled = false,
  extra_options = [],
}: Props) {
  const [options, setOptions] = useState<DisablableOption[]>([]); 
  const [my_extra_options, setExtraOptions] = useState<string[]>([]);

  useEffect(() => {
    const load = () => {
      const use_conditions = option_objects ? option_objects : api.conditions;
      const new_options: DisablableOption[] = use_conditions.map(obj => toDisablableOption({ obj }));
      setOptions(new_options);
      const new_extra_options = [...extra_options];
      if (resistances) {
        new_extra_options.push(...DAMAGE_TYPES.map(o => `${o} Resistance`));
      }
      if (vulnerabilities) {
        new_extra_options.push(...DAMAGE_TYPES.map(o => `${o} Vulnerability`));
      }
      if (immunities) {
        new_extra_options.push(...DAMAGE_TYPES.map(o => `${o} Immunity`));
      }
      setExtraOptions(new_extra_options);
    }
    load();
  }, [option_objects, resistances, vulnerabilities, immunities, extra_options]);

  return (
    <SelectStringBox
      name={name}
      value={value}
      values={values}
      options={options}
      extra_options={my_extra_options}
      color={color}
      multiple={multiple}
      disabled={disabled}
      onChange={onChange}
      // log_it
    />
  );
}
